import { useCallback, useMemo } from "react";
import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import useRouteName from "../../../hooks/useRouteName";

const util = createTrackingUtils({
  name: "flights_web_ddot_checkout_improved_heading",
  defaultStage: 1,
  stages: {
    main: 1,
    bf: 2,
    flex: 3,
    seat: 4,
    direct: 5,
    meta: 6,
    solo: 7,
    nonSolo: 8,
    us: 9
  },
  goals: {},
  goalsWithValue: []
});

export default function useFlightsWebDdotCheckoutImprovedHeading() {
  const routeName = useRouteName();
  const { isSolo, isAmerican, isDirect } = useProfiler();

  const isVariant = useMemo(() => {
    if (!routeName.startsWith("checkout")) return false;
    if (routeName.startsWith("pb-")) return false;
    return !!util.trackWithDefaultStage();
  }, [routeName]);

  const trackStages = useCallback(() => {
    util.stages.main();
    if (routeName === "checkout-fare") util.stages.bf();
    if (routeName === "checkout-ticket-type") util.stages.flex();
    if (routeName === "checkout-seat-selection") util.stages.seat();
    if (isDirect()) util.stages.direct();
    if (!isDirect()) util.stages.meta();
    if (isSolo()) util.stages.solo();
    if (!isSolo()) util.stages.nonSolo();
    if (isAmerican()) util.stages.us();
  }, [routeName, isAmerican, isSolo, isDirect]);

  return { isVariant, trackStages };
}
